<template>
  <div v-if="!price" v-once />
  <div v-else-if="readonly " v-once class="d-flex flex-column text-center">
    <div v-if="priceDiscounted"
         class="text-decoration-line-through text-caption"
         style="line-height: 0.7rem"
         v-text="price"
    />
    <div>
      {{ priceDiscounted || price }}
    </div>
  </div>
  <div v-else>
    <v-btn v-if="inBasket"
           v-bind="theme"
           x-small
           color="grey"
           height="36"
           class="rounded-r-0"
           @click="minus()"
           @click.native="$ym.do('product_minus')"
    >
      <v-icon>mdi-minus</v-icon>
    </v-btn>
    <v-btn v-bind="theme"
           :color="color"
           :class="{[classes]: true, 'rounded-l-0 pl-3': inBasket}"
           @click="click"
           @click.native="$ym.do(ymCode)"
    >
      <div class="d-flex flex-column">
        <div v-if="priceDiscounted"
             class="text-decoration-line-through text-caption"
             style="line-height: 0.7rem"
             v-text="price"
        />
        <div>
          {{ priceDiscounted || price }}
        </div>
      </div>
      <v-icon right :large="inBasket > 0">
        {{ inBasket ? 'mdi-plus' : 'mdi-cart-arrow-down' }}
      </v-icon>
    </v-btn>
    <v-badge v-if="inBasket"
             :content="inBasket"
             :value="inBasket"
             color="transparent"
             offset-x="18"
             offset-y="-14"
             :dark="theme.light"
             :light="theme.dark"
    >
      <template v-slot:badge>
        <v-btn :dark="theme.dark" :light="theme.light" :color="color" fab width="24px" height="24px">
          {{ inBasket }}
        </v-btn>
      </template>
    </v-badge>
  </div>
</template>

<script>

export default {
  name: 'ProductAction',
  props: {
    mode: { type: String, default: null },
    menu: { type: String, default: null },
    price: { type: [Number, String], default: null, },
    priceDiscounted: { type: [Number, String], default: null, },
    inBasket: { type: [Number, String], default: null, },
    readonly: { type: Boolean, default: false },
  },
  created() {
    const { theme } = this.$store.state;

    this.tile = theme.buyButtonType === 'tile';
    this.text = theme.buyButtonType === 'text';
    this.rounded = theme.buyButtonType === 'rounded';
    this.elevation = theme.buyButtonElevation;
    this.dark = theme.buyButtonDark;

    this.theme = {
      tile: theme.buyButtonType === 'tile',
      text: theme.buyButtonType === 'text',
      rounded: theme.buyButtonType === 'rounded',
      elevation: theme.buyButtonElevation,
      dark: theme.buyButtonDark,
      light: !theme.buyButtonDark,
    };

    if (this.mode === 'ok' || this.mode === 'need_location') {
      this.color = theme.buyButtonColor;
    } else {
      this.color = 'gray';
    }
    this.classes = `restion-store__button--${this.mode}`;
    this.ymCode = `product_${this.mode}`;
  },
  methods: {
    click() {
      switch (this.mode) {
        case 'bad_menu_time':
          this.$store.commit('ui/dialog', { name: 'OutOfMenuTime', props: { menu: this.menu } });
          break;
        case 'can_not_deliver':
          this.$store.commit('ui/dialog', { name: 'CanNotDeliver' });
          break;
        case 'can_not_pickup':
          this.$store.commit('ui/dialog', { name: 'CanNotPickUp' });
          break;
        case 'need_location':
          this.$store.commit('ui/dialog', { name: 'NeedLocation' });
          break;
        case 'bad_order_time':
          this.$store.commit('ui/dialog', { name: 'OutOfOrderTime' });
          break;
        default:
          this.$emit('plus');
          break;
      }
    },
    minus() {
      this.$emit('minus');
    },

  }
};
</script>
